import { Component, OnInit } from '@angular/core';
import { NeproseService } from '../services/neprose.service';
import { SeoSocialShareData, SeoSocialShareService } from 'ngx-seo';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-pricing',
  templateUrl: './pricing.component.html',
  styleUrls: ['./pricing.component.css']
})
export class PricingComponent implements OnInit {
  adPlans = []

  seoData: SeoSocialShareData = {
    title:  'Neprose - Pricing',
    description: 'Your next real estate investment opportunity could be right around the corner.',
    image: environment.url+'/assets/logo.png',
    type: 'website'
  };

  constructor( private seo: SeoSocialShareService, private neproseService: NeproseService) { }

  ngOnInit(): void {
    this.seo.setData(this.seoData)
    this.getAdPlans()
  }

  getAdPlans() {
    this.neproseService.getAdPlans().subscribe(data => {
      this.adPlans = data.adPlans;
    });
  }

}
